import { ExceptionEvent } from "@fairfleet/geotab";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useDeviceById } from "@/hooks/devices/useDeviceById";
import { useUserById } from "@/hooks/users/useUserById";
import i18n from "@/i18n";
import { safeLocale } from "@/utilities/i18n/safeLocale";

export default function AccidentDataTable({ event }: { event: ExceptionEvent }) {
  const { device, driver, activeFrom, duration } = event;

  const { data: user } = useUserById(driver?.id);
  const driverName = user?.name;

  const { data: vehicle } = useDeviceById(device?.id);
  const deviceName = vehicle?.name;

  const formattedDate = activeFrom
    ? new Date(activeFrom).toLocaleString(safeLocale(i18n.language), {
        hour: "2-digit",
        minute: "2-digit",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        second: "2-digit",
        hour12: false,
      })
    : "";

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{"Fahrer"}</TableCell>
            <TableCell>{driverName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{"Fahrzeug"}</TableCell>
            <TableCell>{deviceName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{"Datum"}</TableCell>
            <TableCell>{formattedDate}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{"Dauer"}</TableCell>
            <TableCell>{duration}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
